import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PensionContext } from '../../../contexts/pension-robot/PensionContext';
import { BackButton, NextButton } from './NavigationButtons';
import { YesNoFormGroup } from '../../general/form-inputs/YesNoFormGroup';
import { NibudModal } from '../expenses-overlay/NibudModal';
import { CocktailWrapperScreen } from './CocktailWrapperScreen';
import { CurrencyFormGroup } from '../../general/form-inputs/CurrencyFormGroup';
import { SavingButtons } from './DialogueDataSaver';

export const ExpensesSection: React.FC<{}> = () => {
    const { t } = useTranslation('pension');

    return (
        <>
            <CocktailWrapperScreen 
                page={2} 
                title={t('pension-cocktail-fill-screen-costs-title')}
            >
            <ExpensesSectionInputs/>
            </CocktailWrapperScreen>
        </>
    );
};

export const ExpensesSectionInputs: React.FC<{}> = () => {
    const { t } = useTranslation('pension');
    const {
        parameters: { personalInfo, expensesInfo },
        actions,
    } = useContext(PensionContext);

    const [showNibudModal, setShowNibudModal] = useState(false);

    return (
        <>
            <YesNoFormGroup
                className="mb-8"
                title={{
                    label: t('pension-cocktail-fill-screen-expenses-goal-label'),
                    tooltip: { title: 'TODO', text: 'TODO' },
                }}
                value={expensesInfo?.isKnown === undefined ? null : expensesInfo?.isKnown ? 'yes' : 'no'}
                onChange={(value) => {
                    if (value === 'yes') {
                        actions.setParameters({ expensesInfo: { isKnown: true } });
                    }
                    if (value === 'no') {
                        actions.setParameters({ expensesInfo: { isKnown: false } });
                        setShowNibudModal(!expensesInfo?.goal);
                    }
                }}
            />

            {/* Manual version */}
            {!!expensesInfo?.isKnown && (
                <CurrencyFormGroup
                    className="mb-8 w-full"
                    value={expensesInfo.goal}
                    title={{
                        label: t('pension-cocktail-fill-screen-expenses-goal-input'),
                        tooltip: {
                            title: 'Todo',
                            text: 'Todo text...',
                        },
                    }}
                    currencyInputProps={{
                        placeholder: `€ ${t('pension-cocktail-fill-screen-expenses-goal-placeholder')}`,
                    }}
                    onChange={(cents) => {
                        actions.setParameters({ expensesInfo: { goal: cents } });
                    }}
                />
            )}

            {/* Nibud version */}
            {!expensesInfo?.isKnown && (
                <CurrencyFormGroup
                    title={{
                        label: t('pension-cocktail-fill-screen-expenses-goal-nibud'),
                    }}
                    value={expensesInfo?.goal}
                    button={{
                        onClick: () => {
                            actions.setParameters({
                                expensesInfo: {
                                    modalStep: 1,
                                },
                            });
                            setShowNibudModal(true);
                            
                        },
                        label: t('pension-cocktail-fill-screen-expenses-goal-nibud-recalculate'),
                    }}
                    className="mb-8 w-full"
                    onChange={(cents) => {
                        actions.setParameters({ expensesInfo: { goal: cents } });
                    }}
                    currencyInputProps={{
                        placeholder: `€ ${t('pension-cocktail-fill-screen-expenses-goal-placeholder')}`,
                    }}
                />
            )}
            {!!expensesInfo &&
            !!expensesInfo.goal &&
            !!personalInfo &&
            !!personalInfo.self &&
            !!personalInfo.self.salary ? (
                expensesInfo.goal - personalInfo.self.salary >= 50000 ? (
                    <div className="shadow-lg-all-sides border-l-4 border-bnd-orange max-w-3xl p-4 rounded-lg bg-white">
                        <span className="font-bold text-bnd-orange">Let op:</span> Uw verwachte uitgaven liggen
                        flink hoger dan uw huidige inkomen.
                    </div>
                ) : (
                    ''
                )
            ) : (
                ''
            )}

            <div className="flex flex-row flex-wrap gap-4 items-start my-8">
                <BackButton />
                <NextButton nextPage="pension" isDisabled={!expensesInfo?.goal} />
            </div>
            <SavingButtons/>
            <NibudModal
                isShown={showNibudModal}
                onClose={() => {
                    setShowNibudModal(false);
                }}
            />
        </>
    );
};
